import React, { createContext, useContext, useState, useEffect } from 'react';
import { getFavoriteIds, toggleFavorite as apiToggle } from '../services/api';
import { useAuth } from './AuthContext';

const FavoritesContext = createContext({ favoriteIds: [], toggle: () => {} });

export function FavoritesProvider({ children }) {
  const { client } = useAuth();
  const [favoriteIds, setFavoriteIds] = useState([]);

  useEffect(() => {
    if (client) {
      getFavoriteIds()
        .then(res => setFavoriteIds(res.data))
        .catch(() => setFavoriteIds([]));
    } else {
      setFavoriteIds([]);
    }
  }, [client]);

  const toggle = async (vehicleId) => {
    const res = await apiToggle(vehicleId);
    if (res.data.favorited) {
      setFavoriteIds(prev => [...prev, vehicleId]);
    } else {
      setFavoriteIds(prev => prev.filter(id => id !== vehicleId));
    }
    return res.data.favorited;
  };

  return (
    <FavoritesContext.Provider value={{ favoriteIds, toggle }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  return useContext(FavoritesContext);
}
